import styled from 'styled-components';
import { Typ32 } from 'dc/Typ';
import ButtonComponent from 'dc/Button';

import LanguageSelector from '../LanguageSelector';

export const Nav = styled.nav`
  width: 100%;
  height: 80px;
  background-color: white;
  padding: 0 60px 0 23px;
  border-bottom: 1px solid #eceff1;
`;

export const Items = styled.span`
  display: flex;
  align-items: center;
`;

export const List = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
`;

export const Language = styled(LanguageSelector)`
  margin: 0 18px;
`;

export const HomeBar = styled.div`
  height: 24px;
  border: 1px solid #455a64;
  margin: 0 24px;
`;

export const Bar = styled.div`
  height: 24px;
  border: 1px solid #455a64;
  margin: 0 6px;
`;

export const Link = styled(Typ32)`
  padding: 0 18px;
  color: #455a64;
  &:hover {
    color: #007079;
  }
`;

export const Button = styled(ButtonComponent)``;

export const StyledLink = styled.a`
  height: fit-content;
`;

export const ListItem = styled.li`
  list-style: none;
`;

export const Image = styled.img`
  max-height: 50px;
  width: 100%;
  height: auto;
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SponsorsWrapper = styled.div`
  display: flex;
  gap: 56px;
  justify-content: flex-start;
  align-items: center;
  margin-right: 24px;
`;
